<script>
    const PIXEL_RATIO = window.devicePixelRatio || 1;

    export default {
        name: 'PDFPage',
        props: {
            zoom: Number,
            page: {
                type: Object, // instance of PDFPageProxy returned from pdf.getPage
                required: true,
            },
            scale: {
                type: Number,
                required: true,
            },
            isPageFocused: {
                type: Boolean,
                default: false,
            },
            isElementVisible: {
                type: Boolean,
                default: false,
            },
            isElementFocused: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            actualSizeViewport() {
                return this.viewport.clone({scale: this.scale * this.zoom});
            },
            canvasStyle() {
                const {width: actualSizeWidth, height: actualSizeHeight} = this.actualSizeViewport;
                const [pixelWidth, pixelHeight] = [actualSizeWidth, actualSizeHeight].map(dim => Math.ceil(dim / PIXEL_RATIO));
                return `width: ${pixelWidth}px; height: ${pixelHeight}px;`;
            },
            canvasAttrs() {
                let {width, height} = this.viewport;
                [width, height] = [width, height].map(dim => Math.ceil(dim));
                const style = this.canvasStyle;

                return {
                    width,
                    height,
                    style,
                    class: 'pdf-page box-shadow',
                };
            },
            pageNumber() {
                return this.page.pageNumber;
            },
        },
        methods: {
            focusPage() {
                if (this.isPageFocused)
                    return;

                this.$emit('page-focus', this.pageNumber);
            },
            drawPage() {
                if (this.renderTask)
                    return;

                const {viewport} = this;
                const canvasContext = this.$el.getContext('2d');
                const renderContext = {canvasContext, viewport};

                this.renderTask = this.page.render(renderContext).promise;
                this.renderTask.then(() => {
                    this.$emit('page-rendered', {
                        page: this.page,
                        text: `Rendered page ${this.pageNumber}`,
                    });
                }).catch(response => {
                    this.destroyRenderTask();
                    this.$emit('page-errored', {
                        response,
                        page: this.page,
                        text: `Failed to render page ${this.pageNumber}`,
                    });
                });
            },
            updateVisibility() {
                this.$parent.$emit('update-visibility');
            },
            destroyPage(page) {
                if (page)
                    page._destroy();

                this.destroyRenderTask();
            },
            destroyRenderTask() {
                if (!this.renderTask)
                    return;

                this.renderTask.then(task => {
                    if (task)
                        task.cancel();
                });
                delete this.renderTask;
            },
        },
        watch: {
            scale: 'updateVisibility',
            page(_newPage, oldPage) {
                this.destroyPage(oldPage);
            },
            isElementFocused(isElementFocused) {
                if (isElementFocused)
                    this.focusPage();
            },
            isElementVisible(isElementVisible) {
                if (isElementVisible)
                    this.drawPage();
            },
        },
        created() {
            this.viewport = this.page.getViewport({ scale: this.scale * this.zoom });
        },
        mounted() {
            console.log(`Page ${this.pageNumber} mounted`);
        },
        beforeDestroy() {
            this.destroyPage(this.page);
        },
        render(h) {
            const {canvasAttrs: attrs} = this;
            return h('canvas', {attrs});
        },
    };
</script>

<style lang="scss">
    .pdf-page {
        display: block;
        -webkit-box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.75);
        box-shadow: 0px 0px 10px 3px rgba(0, 0, 0, 0.75);
        margin: 1px auto 15px auto;
        &:first-of-type {
            margin-top: 5em;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/pdfViewer/PDFPage.vue